import { StepError, StepErrorKey } from './stepError.model';

export const StepKey = {
  Greetings: 'Greetings',
  PartnerDetails: 'PartnerDetails',
  BankAccount: 'BankAccount',
  SignDocuments: 'SignDocuments',
  Completed: 'Completed',
} as const;

export type StepKey = (typeof StepKey)[keyof typeof StepKey];

export const StepStatus = {
  Pending: 'Pending',
  Completed: 'Completed',
  Blocked: 'Blocked',
  NeedsAttention: 'NeedsAttention',
} as const;

export type StepStatus = (typeof StepStatus)[keyof typeof StepStatus];

export class Step {
  key: StepKey;
  order: number;
  status: StepStatus;
  errors: StepError[];

  constructor(key: StepKey, order: number, status: StepStatus, errors: StepError[]) {
    this.key = key;
    this.order = order;
    this.status = status;
    this.errors = errors;
  }

  get isStepCompleted(): boolean {
    const completedStatuses: StepStatus[] = ['NeedsAttention', 'Completed'];
    return completedStatuses.includes(this.status);
  }

  get isStepPending(): boolean {
    return this.status === 'Pending';
  }

  get isStepBlocked(): boolean {
    const hasAtLeastOneBlockingError = this.errors.some((error) => error.isBlockingError);
    return this.status === 'Blocked' || hasAtLeastOneBlockingError;
  }

  get blockingErrors(): StepError[] | null {
    const blockingErrors = this.errors.filter((error) => error.isBlockingError);
    if (!blockingErrors.length) return null;

    return blockingErrors;
  }

  getBlockingErrorMessageByKey(errorKey: StepErrorKey): string | null {
    if (!this.blockingErrors) return null;

    const error = this.blockingErrors.find(
      (error) => error.isBlockingError && error.key === errorKey
    );

    if (!error) return null;
    return error.message;
  }
}
